import * as React from 'react';
import classnames from "classnames";
import {Col, Input, Row, CardBody, Tooltip} from "reactstrap";
import {useState, useRef, useEffect} from 'react';
import {NumericInput} from "../numeric/numericInput";
import {forwardRef, useImperativeHandle} from "react";

export const SliderInputs = forwardRef((props, ref) => {
	const {isError, question, touched, onValueChangeFirst, onValueChangeSecond, detail} = props

	useImperativeHandle(ref, () => ({
		setInputValueForce(detail) {
			if (numericOneRef && numericOneRef.current && numericOneRef.current.setInputValueForce) {
				let value1 = Number(detail.value1) || 0;
				if (question.decimals) {
					value1 = value1 / Math.pow(10, question.decimals)
				}

				numericOneRef.current.setInputValueForce(Number(value1));
			}
			if (numericTwoRef && numericTwoRef.current && numericTwoRef.current.setInputValueForce) {
				let value2 = Number(detail.value2) || 0;
				if (question.decimals) {
					value2 = value2 / Math.pow(10, question.decimals)
				}

				numericTwoRef.current.setInputValueForce(Number(value2));
			}
		}
	}));

	const numericOneRef = useRef();
	const numericTwoRef = useRef();
	let value1 = Number(detail.value1) || 0;
	if (question.decimals) {
		value1 = value1 / Math.pow(10, question.decimals)
	}

	let value2 = Number(detail.value2) || 0;
	if (question.decimals) {
		value2 = value2 / Math.pow(10, question.decimals)
	}

	return (
		<div className={classnames({
			"d-none": !touched || !question.showSliderInputs,
			"d-block": touched && question.showSliderInputs
		})}>
			<Row>
				<Col className={classnames({
					'col-12 col-lg-6': question.range,
					'col-12 col-lg-12': !question.range,
					'mt-1 mb-4': true
				})}>
					<NumericInput
						ref={numericOneRef}
						error={isError}
						value={value1}
						question={question}
						changeValue={(value) => {
							if (question.decimals) {
								value = value * Math.pow(10, question.decimals)
							}

							onValueChangeFirst(value)
						}}
					/>
				</Col>
				{question.range && <Col className={classnames({
					'col-12 col-lg-6': question.range,
					'col-12 col-lg-12': !question.range,
					'mt-1 mb-4': true
				})}>
					<NumericInput
						ref={numericTwoRef}
						error={isError}
						value={value2}
						question={question}
						changeValue={(value) => {
							if (question.decimals) {
								value = value * Math.pow(10, question.decimals)
							}

							onValueChangeSecond(value)
						}}
					/>
				</Col>}
			</Row>
		</div>
	);
})